<template>
  <div class="learun-form-item">
    <div class="learun-form-item__title">{{ title }}</div>
    <div class="learun-form-item__content"><slot></slot></div>
  </div>
</template>
<script>
export default {
  name: "learun-form-item",
  props: {
    title: String,
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>